import React, { useState, useRef } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Box,
    Typography,
    Divider
} from '@mui/material';
import CustomButton from 'components/Fileds/CustomButton';
import CustomTypography from 'components/Fileds/CustomTypography';
import { useGetAvailableRidersQuery } from 'pages/manageAccounts/services';
import './style.css';
import theme from 'theme/ThemeContext';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CustomRadio from 'components/Fileds/CustomRadio';
import RiderTabs from './RiderTabs';
import { QRCodeSVG } from 'qrcode.react';

const OrderRiderAssign = ({
    open,
    onClose,
    onSubmit,
    loading = false,
    selectedRider,
    setSelectedRider,
    orderDetails
}) => {
    const { data: ridersData, isLoading: loadingRiders } = useGetAvailableRidersQuery(
        undefined,
        { skip: !open, refetchOnMountOrArgChange: true }
    );
    
    const [activeTab, setActiveTab] = useState('riders');
    const qrPrintRef = useRef(null);

    const riders = Array.isArray(ridersData?.data) ? ridersData.data : [];

    const handlePrintQR = () => {
        // if (!qrPrintRef.current) return;
        // const printWindow = window.open('', '_blank');
        // if (!printWindow) return;
        // printWindow.document.write(`
        //     <html>
        //         <head>
        //             <title>Print QR</title>
        //             <style>
        //                 body { display: flex; justify-content: center; align-items: center; margin: 0; padding: 20px; font-family: sans-serif; }
        //                 .qr-container { text-align: center; border: 1px solid #ddd; padding: 20px; border-radius: 12px; }
        //                 .title { font-weight: bold; font-size: 18px; margin-bottom: 5px; }
        //                 .subtitle { font-size: 14px; margin-bottom: 20px; color: #555; }
        //             </style>
        //         </head>
        //         <body>
        //             <div class="qr-container">
        //                 ${qrPrintRef.current.innerHTML}
        //             </div>
        //         </body>
        //     </html>
        // `);
        // printWindow.document.close();
        // printWindow.focus();
        // setTimeout(() => {
        //     printWindow.print();
        //     printWindow.close();
        // }, 200);
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            className="rider-assign-dialog-container"
            PaperProps={{
                sx: {
                    borderRadius: "20px",
                    backgroundColor: "white",
                    width: '400px'
                },
            }}
        >
            <DialogTitle className='rider-assign-title'>Assign Rider</DialogTitle>
            <DialogContent sx={{ paddingBottom: '0px !important', px: 0 }}>
                <Box sx={{ padding: '0px 20px' }}>
                    <CustomTypography variant="body1"
                        label={
                            <>
                                <span style={{ fontWeight: '500' }}>Order Id:</span> {orderDetails?.order_id ? `#${orderDetails?.order_id}` : 'N/A'}
                            </>
                        }
                    />
                </Box>
               <Divider sx={{ my: 1, borderColor: '#D9D9D9 !important' }} />
                <RiderTabs activeTab={activeTab} onChange={setActiveTab} />

                <Divider sx={{ my: 1, borderColor: '#D9D9D9 !important' }} />

                <Box sx={{ height: '240px', overflow: 'auto', px: 1 }}>
                    {activeTab === 'riders' ? (
                        <>
                            {loadingRiders ? (
                                <Typography sx={{ textAlign: 'center', mt: 2 }}>Loading riders...</Typography>
                            ) : riders.map((rider) => (
                                <Box
                                    key={rider.id}
                                    className="d-flex align-items-center"
                                    onClick={() => setSelectedRider(rider.id)}
                                    sx={{
                                        mx: 2,
                                        py: 0.5,
                                        width: 'auto',
                                        cursor: 'pointer',
                                        backgroundColor: 'transparent',
                                        borderBottom: '1px solid #f0f0f0',
                                        '&:last-child': {
                                            borderBottom: 'none'
                                        }
                                    }}
                                >
                                    <CustomRadio
                                        checked={selectedRider === rider.id}
                                        onChange={() => setSelectedRider(rider.id)}
                                        value={rider.id}
                                        name={`rider-radio-${rider.id}`}
                                        sx={{ color: '#000', padding: '4px', '&.Mui-checked': { color: '#000' } }}
                                        label={
                                            <span style={{ fontWeight: selectedRider === rider.id ? 600 : 400, marginLeft: '8px', fontSize: '15px' }}>
                                                {rider.full_name || rider.username}
                                            </span>
                                        }
                                    />
                                </Box>
                            ))}
                            {!loadingRiders && riders.length === 0 && (
                                <Typography sx={{ textAlign: 'center', mt: 2 }}>No riders available</Typography>
                            )}
                        </>
                    ) : (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems:'center', py: 2, height:'100%' }}>
                            <Box ref={qrPrintRef} sx={{ textAlign: 'center' }}>
                                <QRCodeSVG 
                                    value={orderDetails?.qr_code_token || ""} 
                                    size={150} 
                                    level="M"
                                />
                            </Box>
                        </Box>
                    )}
                </Box>

                <Divider sx={{ mt: 0.5, borderColor: '#D9D9D9 !important' }} />
            </DialogContent>

            <DialogActions className='d-flex align-items-center' sx={{ my: 1, justifyContent: 'center !important', gap: '10px', width:'100%' }}>
                <CustomButton
                    onClick={onClose}
                    disabled={loading}
                    sx={{
                        backgroundColor: 'transparent',
                        width: '48%',
                    }}
                    variant="outlined"
                    className='close-btn'
                >
                    Cancel
                </CustomButton>

                {activeTab === 'riders' ? (
                    <CustomButton
                        onClick={onSubmit}
                        disabled={loading || !selectedRider}
                        variant="contained"
                        className='confirm-btn'
                        sx={{width:'48%'}}
                    >
                        {loading ? 'Assigning...' : 'Assign'}
                    </CustomButton>
                ) : (
                    <CustomButton
                        onClick={handlePrintQR}
                        variant="contained"
                        className='confirm-btn'
                        sx={{width:'48%'}}
                    >
                        Print QR
                    </CustomButton>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default OrderRiderAssign;
